import { useAutomationWizardFormContext } from './automation-wizard-form';
import { useAutomationActionsController } from './use-automation-actions-controller';
import { useAutomationConditionsController } from './use-automation-conditions-controller';
import { useNavigationController } from './use-automation-navigation-controller';
import { useAutomationSettingsController } from './use-automation-settings-controller';

export function useAutomationWizardController() {
  const form = useAutomationWizardFormContext();
  const navigationController = useNavigationController();
  const settingsController = useAutomationSettingsController();
  const conditionsController = useAutomationConditionsController();
  const actionsController = useAutomationActionsController();

  const automation = form.getValues();

  return {
    form,
    automation,
    settings: settingsController,
    navigation: navigationController,
    conditions: conditionsController,
    actions: actionsController,
  };
}
